module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-head-top"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/81388_content#p1"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("PART ONE")])])]), _vm._v(" "), _c('div', {
    staticClass: "head2"
  }), _vm._v(" "), _c('p', {
    staticClass: "big-head"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/81388_content#p1"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("BEGINNINGS")])])]), _vm._v(" "), _c('div', {
    staticClass: "head2"
  }), _vm._v(" "), _c('p', {
    staticClass: "part-ital-head"
  }, [_vm._v("There was no notion of where we were going, but no known cure either.")]), _vm._v(" "), _c('div', {
    staticClass: "partimages"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/part1_001.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "phototxtfirst"
  }, [_vm._v("© Redferns")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5637e5e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/81388_part1.vue
// module id = 72
// module chunks = 0